import "../../App.css";

export const LoaderClassic = () => {
  return <div className="loaderClassic"></div>;
};
